<app-users-list-filters
  [filters]="filters"
  (filtersUpdated)="updateFilters($event)"></app-users-list-filters>
<app-users-list-table
  [dataArr]="users"
  [isLoading]="isLoading"
  [tableFilters]="filters.tableFilters"
  (tableFiltersUpdated)="updateTableFilters($event)"
  (updateTable)="updateUserList(filters)"></app-users-list-table>
